<template>
  <div class="homePage">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          :style="
            'background:url(' +
            require('@img/banner.jpg') +
            ');background-position: center;background-repeat: no-repeat;'
          "
        >
          <div class="bannerContain">
            <div class="container">
              <h2>{{ $t("home.banner1") }}</h2>
              <p>{{ $t("home.bannerEnglish1") }}</p>
            </div>
          </div>
        </div>
        <div
          class="swiper-slide"
          :style="
            'background:url(' +
            require('@img/banner_2.jpg') +
            ');background-position: center;background-repeat: no-repeat;'
          "
        >
          <div class="bannerContain">
            <div class="container">
              <h2>{{ $t("home.banner2") }}</h2>
              <p>{{ $t("home.bannerEnglish2") }}</p>
            </div>
          </div>
        </div>
        <div
          class="swiper-slide"
          :style="
            'background:url(' +
            require('@img/banner_3.jpg') +
            ');background-position: center;background-repeat: no-repeat;'
          "
        >
          <div class="bannerContain">
            <div class="container">
              <h2>{{ $t("home.banner3") }}</h2>
              <p>{{ $t("home.bannerEnglish3") }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination">
        <ul>
          <li
            :class="swiperIndex == 0 ? 'active' : ''"
            @click="setSwiperIndex(0)"
          ></li>
          <li
            :class="swiperIndex == 1 ? 'active' : ''"
            @click="setSwiperIndex(1)"
          ></li>
          <li
            :class="swiperIndex == 2 ? 'active' : ''"
            @click="setSwiperIndex(2)"
          ></li>
        </ul>
      </div>
    </div>
    <div class="functions">
      <div
        class="funcItem"
        :class="
          funcIndex == index
            ? 'activeFuncItem animate__animated animate__headShake'
            : ''
        "
        @mouseover="clickFuncItem(index)"
        v-for="(item, index) in funcInfo"
        :key="index"
      >
        <img :src="funcIndex == index ? item.activeImg : item.img" />
        <p>{{ $t(`home.funcItems.${item.title}`) }}</p>
        <span>{{ $t(`home.funcItems.${item.intro}`) }}</span>
        <span
          class="line"
          v-show="index != 3 && funcIndex != index && funcIndex - 1 != index"
        ></span>
      </div>
    </div>
    <div class="funcDetail">
      <div class="container">
        <div class="wow fadeInUp">
          <part-title
            style="margin-bottom: 28px"
            :title="this.$t(`home.advantage.bigtitle1`)"
          ></part-title>
        </div>
        <div class="artc flex-d-c wow fadeInUp">
          <p class="wow fadeInUp" data-wow-delay="0.1s">
            {{ $t("home.description.p1") }}
          </p>
          <p class="wow fadeInUp" data-wow-delay="0.2s">
            {{ $t("home.description.p2") }}
          </p>
          <p class="wow fadeInUp" data-wow-delay="0.3s">
            {{ $t("home.description.p3") }}
          </p>
          <p class="wow fadeInUp" data-wow-delay="0.4s">
            {{ $t("home.description.p4") }}
          </p>
          <p class="wow fadeInUp" data-wow-delay="0.5s">
            {{ $t("home.description.p5") }}
          </p>
          <p class="wow fadeInUp" data-wow-delay="0.5s">
            {{ $t("home.description.p6") }}
          </p>
        </div>
      </div>
      <img class="rightBgImg" src="@img/bg_world map@2x.png" />
    </div>
    <div class="advantage wow fadeInUp">
      <part-title
        :title="this.$t(`home.advantage.bigtitle2`)"
        class="wow fadeInUp"
      ></part-title>
      <div class="container">
        <div class="advanItem">
          <img class="advanImg fl" src="@img/img_flat@2x.png" alt />
          <div class="advanInfo">
            <div class="advanInfoTitle wow fadeInUp" data-wow-delay="0.1s">
              <img class="advanBgIcon" src="@img/ico_r_flat.png" alt />
              <h3>{{ $t("home.advantage.title1") }}</h3>
              <img class="advanBg" src="@img/img_colon@2x.png" alt />
            </div>
            <p class="wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("home.advantage.des1") }}
            </p>
            <div class="card wow fadeInUp" data-wow-delay="0.3s">
              {{ $t("home.advantage.card1") }}
            </div>
          </div>
        </div>

        <div class="advanItem">
          <div class="advanInfo fl">
            <div class="advanInfoTitle wow fadeInUp" data-wow-delay="0.1s">
              <img src="@img/ico_r_cloud.png" alt />
              <h3>{{ $t("home.advantage.title2") }}</h3>
              <img class="advanBg" src="@img/img_colon@2x.png" alt />
            </div>
            <p class="wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("home.advantage.des2") }}
            </p>
            <div class="card wow fadeInUp" data-wow-delay="0.3s">
              {{ $t("home.advantage.card2") }}
            </div>
          </div>
          <img class="advanImg fr" src="@img/img_ai@2x.png" alt />
        </div>

        <div class="advanItem">
          <img class="advanImg fl" src="@img/img_cloud@2x.png" alt />
          <div class="advanInfo">
            <div class="advanInfoTitle wow fadeInUp" data-wow-delay="0.1s">
              <img src="@img/ico_r_synergy.png" alt />
              <h3>{{ $t("home.advantage.title3") }}</h3>
              <img class="advanBg" src="@img/img_colon@2x.png" alt />
            </div>
            <p class="wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("home.advantage.des3") }}
            </p>
            <div class="card wow fadeInUp" data-wow-delay="0.3s">
              {{ $t("home.advantage.card3") }}
            </div>
          </div>
        </div>

        <div class="advanItem">
          <div class="advanInfo fl">
            <div class="advanInfoTitle wow fadeInUp" data-wow-delay="0.1s">
              <img src="@img/ico_r_ai.png" alt />
              <h3>{{ $t("home.advantage.title4") }}</h3>
              <img class="advanBg" src="@img/img_colon@2x.png" alt />
            </div>
            <p class="wow fadeInUp" data-wow-delay="0.2s">
              {{ $t("home.advantage.des4") }}
            </p>
            <div class="card wow fadeInUp" data-wow-delay="0.3s">
              {{ $t("home.advantage.card4") }}
            </div>
          </div>
          <img class="advanImg fr" src="@img/img_synergy@2x.png" alt />
        </div>
      </div>
    </div>
    <team-bar style="margin-bottom: 80px"></team-bar>
    <!-- <div class="partner container">
      <part-title title="合作伙伴" class="wow fadeInUp"></part-title>
      <img class="partnerLogo wow fadeInUp" data-wow-delay="0.2s" src="@img/img_logo@2x.png" alt>
    </div>

    <div class="footerImg">
      <img src="@img/img_neural network@2x.png" alt>
    </div>-->
    <page-footer></page-footer>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/swiper.min.css";
import pageFooter from "@/components/footer";
import partTitle from "@/components/title";
import teamBar from "@/components/teamBar";
import { WOW } from "wowjs";
export default {
  components: {
    teamBar,
    pageFooter,
    partTitle,
  },
  data() {
    return {
      wow: "",
      swiperIndex: 0,
      mySwiper: "",
      funcIndex: -1,
      funcInfo: [
        {
          img: require("@img/ico／n／flat.png"),
          activeImg: require("@img/ico／s／flat@2x.png"),
          title: "title1",
          intro: "intro1",
          introTitle: "introTitle1",
        },
        {
          img: require("@img/ico／n／ai.png"),
          activeImg: require("@img/ico／n／ai@2x(1).png"),
          title: "title2",
          intro: "intro2",
          introTitle: "introTitle2",
        },
        {
          img: require("@img/ico／n／cloud.png"),
          activeImg: require("@img/ico／n／cloud(3).png"),
          title: "title3",
          intro: "intro3",
          introTitle: "introTitle3",
        },
        {
          img: require("@img/ico／n／cloud(1).png"),
          activeImg: require("@img/ico／n／cloud@2x(2).png"),
          title: "title4",
          intro: "intro4",
          introTitle: "introTitle4",
        },
      ],
    };
  },
  created() {
    this.wow = new WOW({
      animateClass: "animated",
    });
    this.wow.init();
  },
  mounted() {
    let that = this;
    this.mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal",
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "custom",
      },

      on: {
        transitionEnd: function (e) {
          that.swiperIndex = e.realIndex;
        },
      },
    });
    this.autoPlay();
  },
  methods: {
    setSwiperIndex(index) {
      this.swiperIndex = index;
      this.mySwiper.slideTo(index + 1);
      this.autoPlay();
    },
    autoPlay() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.swiperIndex = this.swiperIndex == 2 ? 0 : this.swiperIndex + 1;
        this.mySwiper.slideTo(this.swiperIndex + 1);
      }, 6000);
    },
    clickFuncItem(index) {
      this.funcIndex = index;
    },
  },
  computed: {
    smallTitle1() {
      return this.$t("home.advantage.title");
    },
  },
};
</script>

<style lang="less" scoped>
.homePage {
  .swiper-container {
    width: 100%;
    height: 900px;
    .swiper-wrapper,
    .swiper-slide,
    .swiper-slide img {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      position: relative;
    }
    .bannerContain {
      height: 100%;
      background: rgba(0, 0, 0, 0.25);
      .container {
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        h2 {
          font-size: 64px;
          color: #ffffff;
          margin-bottom: 30px;
        }
        h3 {
          font-size: 64px;
          color: #ffffff;
          margin-bottom: 30px;
        }
        p {
          font-size: 34px;
          color: #ffffff;
        }
      }
    }
    .swiper-pagination {
      position: absolute;
      bottom: 144px;
      text-align: center;
      width: 100%;
      z-index: 100;
      ul {
        display: inline-block;

        li {
          display: inline-block;
          width: 44px;
          height: 4px;
          background: #c7c7c7;
          margin: 0 5px;
          cursor: pointer;
          &.active {
            width: 44px;
            height: 4px;
            background: #ffffff;
          }
        }
      }
    }
  }
  .functions {
    width: 1280px;
    margin: 0 auto;
    margin-bottom: 20px;
    height: 216px;
    background: #ffffff;
    box-shadow: 0px 4px 16px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: -108px;
    z-index: 100;
    position: relative;
    font-size: 0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    .funcItem {
      width: 25%;
      height: 216px;
      padding: 32px 0;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      &.activeFuncItem {
        height: 240px;
        background: linear-gradient(180deg, #285bcf 0%, #457dfb 100%);
        border-radius: 16px;
        padding: 44px 0;
        transition: 0.3s;
        p {
          color: #ffffff;
        }
        span {
          color: #ffffff;
        }
      }
      img {
        width: 83px;
        height: 83px;
        margin-bottom: 11px;
      }
      p {
        font-size: 24px;
        color: #5186ff;
        margin-bottom: auto;
      }
      span {
        font-size: 16px;
        color: rgba(51, 51, 51, 0.7);
      }
      .line {
        width: 1px;
        height: 120px;
        background: rgba(51, 51, 51, 0.2);
        position: absolute;
        right: 0;
        top: 48px;
      }
    }
  }
  .funcDetail {
    height: 448px;
    position: relative;
    .container {
      padding-top: 80px;
      .artc {
        p {
          font-size: 20px;
          color: #333333;
          line-height: 34px;
        }
      }
    }
    .rightBgImg {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 517px;
      height: 395px;
    }
  }
  .advantage {
    margin-top: 70px;
    margin-bottom: 20px;
    .container {
      margin-top: 90px;
      .advanItem {
        display: flex;
        align-items: center;
        margin-bottom: 77px;
        .advanImg {
          width: 628px;
          height: 355px;
          &.fl {
            margin-left: -20px;
            margin-right: auto;
          }
          &.fr {
            margin-right: -20px;
          }
        }
        .advanInfo {
          position: relative;
          width: 560px;
          &.fl {
            margin-right: auto;
          }
          .advanInfoTitle {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            position: relative;
            .advanBgIcon {
              width: 56px;
              height: 56px;
              margin-right: 16px;
            }
            h3 {
              font-size: 30px;
              color: #333333;
              font-weight: normal;
            }
            .advanBg {
              position: absolute;
              left: 158px;
              width: 62px;
              height: 52px;
            }
          }
          p {
            font-size: 18px;
            color: #333333;
            margin-bottom: 34px;
            white-space: nowrap;
          }
          .card {
            background: #ffffff;
            box-shadow: 0px 4px 12px 1px rgba(0, 0, 0, 0.2);
            border-radius: 40px 40px 40px 0px;
            font-size: 16px;
            color: rgba(51, 51, 51, 0.75);
            padding: 24px;
            box-sizing: border-box;
            line-height: 28px;
          }
        }
      }
    }
  }
  .partner {
    margin-top: 75px;
    .partnerLogo {
      width: 100%;
      margin-top: 40px;
    }
  }
  .footerImg {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue